<div class="modal-content bg-light">
  <div class="modal-header" *ngIf="title != ''">
    <div class="modal-title text-center" [innerHTML]="title"></div>
  </div>
  <div class="modal-body p-0">
    <ng-content></ng-content>
  </div>
</div>
